import React from 'react';
import chartImageSrc from '../../assets/images/slide/plan-graph-timeline.png';
import styles from './PlanGraphSlideV6.css';

function PlanGraphSlideV6() {
    return (
        <div className={styles.form}>
            <div className={styles.headingSection}>
                <h2 className={styles.heading}>Here is what the next six months could look like</h2>
                <p className={styles.description}>A few minutes at a time can become a private digital book of your life.</p>
            </div>
            <figure className={styles.chart}>
                <img src={`${chartImageSrc}?v=2`} alt='' className={styles.chartImage} />
                <figcaption className={styles.chartNote}>*Illustrative example. Your pace and number of finished chapters may vary.</figcaption>
            </figure>
        </div>
    );
}

export {
    PlanGraphSlideV6
};
